(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('PlannedShipmentController', PlannedShipmentController);

    PlannedShipmentController.$inject = ['$scope', '$state', 'PlannedShipment'];

    function PlannedShipmentController($scope, $state, PlannedShipment) {
        var vm = this;

        vm.plannedShipments = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            PlannedShipment.query(function (result) {
                vm.plannedShipments = result;
            });
        }

        function search() {
            vm.loadAll();
        }
    }
})();
